import React, { Component } from 'react'
import currency from 'currency.js'
import { CheckboxOption } from '@foodsby/nutrient'

class MenuCheckboxAnswers extends Component {
  componentDidUpdate(prevProps) {
    const {
      meta: { error },
    } = prevProps
    if (error) {
      document.getElementById('error') &&
        document
          .getElementById('error')
          .parentNode.childNodes[0].scrollIntoView({ behavior: 'smooth' })
    }
  }
  render() {
    const {
      input,
      meta: { touched, error },
      answers,
      onAnswerChange,
      ...other
    } = this.props
    const { onChange, onBlur, onFocus } = input

    const handleChange = (event, onAnswerChange) => {
      const valueArr = [...input.value]
      onAnswerChange({
        answerId: event.target.value,
        selected: event.target.checked,
      })
      if (event.target.checked) {
        valueArr.push(event.target.value)
      } else {
        valueArr.splice(valueArr.indexOf(event.target.value), 1)
      }
      onBlur(valueArr)
      return onChange(valueArr)
    }

    const excludedErrors = ['min selection error']

    return (
      <div id={touched && error ? 'error' : ''}>
        {touched && error && !excludedErrors.includes(error) && (
          <div className="slide error" name="error">
            {error}
          </div>
        )}
        <ul className="segment-items">
          {answers.map(answer => (
            <li className="Checkbox" key={answer.id}>
              <CheckboxOption
                checked={input.value.includes(`${answer.id}`)}
                id={`answer-${answer.id}`}
                label={answer.text}
                m={1}
                onChange={event => handleChange(event, onAnswerChange)}
                onFocus={onFocus}
                value={answer.id}
                {...other}
                hint={
                  answer.price !== 0 && (
                    <>
                      +
                      {currency(answer.price, {
                        formatWithSymbol: true,
                      }).format()}
                    </>
                  )
                }
              />
            </li>
          ))}
        </ul>
      </div>
    )
  }
}

MenuCheckboxAnswers.defaultProps = {
  meta: {
    error: false,
  },
}

export default MenuCheckboxAnswers
